import React from "react";
import { ErrorMessage } from "formik";

const FormErrorMessage = props => <ErrorMessage {...props} style={{ color: "red" }} />;

export default FormErrorMessage;
